/*
Sohel 01/02/2022 2789725780 dropdown value changes
Suresh Peddavoora 01/04/2022 2789725780 Fixed Textfield Spacing Alignments
Suresh Peddavoora  01/05/2023 2789725780 Modified Textfield Spacings
dilip 01/09/2023 2789725780 Added search data local storage
kavyareddy 01/10/2023 2789725780 Fixed code issue
Suresh Peddavoora  01/11/2023 2789725780 Fixed Responsive issues for Textfields
dilip 01/12/2023 2789725780 Map Records Reset button issue.
Prakash 01/16/2023 2789725780 Added condition and fixed Responsiveness issues.
Suresh Peddavoora  01/18/2023 2789725780 Fixed Map Records button Alignments issue
Sohel 01/19/2023 2789725780 fixed reset issue
dilip 01/20/2023 2789725780 Added Map Exception functionality for IM Record Group
Sohel 01/20/2023 2698964415 changed dropdown values
Suresh Peddavoora 01/25/2023 2698964415 Fixed Button Spacing Alignments in dialogBox
Ashraf 01/27/2023 2789725780 Added new fields category and audit include
Ravi 01/31/2023 2789725780 fixed unsaved popup issue
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Dilip 02/09/2023 2698964415 added creted for  and  creted by fields
suresh peddavoora 02/22/2023 2698964415 New UI changes fixed
suresh peddavoora 02/27/2023 2701335619 New UI changes
Raghu 02/27/2023 2701335619 fixed ui alignments
Raghu 03/14/2023 2701335619 fixed ui alignments
Prakash 03/16/2023 2701335619 fixed ui bugs in responsive.
Prakash 03/17/2023 2701335619 fixed alignments issues.
T Santosh Kumar 17/03/2023 2701335619 New UI Alignment Changes
Prakash 03/17/2023 2701335619 fixed alignments in responsive.
Prakash 03/21/2023 2701335619 Fixed alignments issue.
Prakash 12-04-23 2701335619 fixed buttons issue in import-record-group
Prakash 13/04/2023 2701335619 fixed alignments issue.
Akhila 06/08/2023 2701335619 title label placeholder name change
Akhila 06/08/2023 2701335619 rearrange the column and form fields
Akhila 06/12/2023 2701335619 added role access
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import {useSelector, useDispatch} from 'react-redux';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import SearchIMRTable from './SearchIMRGroupTable';
import {filteredCheckedData, tempSelectFunc} from '../../../../../util/Functions';
import * as Yup from 'yup';
import {createForOptions, createdByOptions} from '../../../../../util/CreatedByForOptions';

const importManagerType = [
  {value: 'New Account Import'},
  // { value: "New Payment Import" },
  {value: 'Data Update'},
  {value: 'Customer Query'},
  {value: 'Exception'},
  {value: 'Header'},
  {value: 'Footer'},
];
const StatusOptions = [
  {key: 'Y', value: 'Draft'},
  {key: 'N', value: 'Completed'},
];

function SearchImportMRGroup({
  setValue,
  mapRecords = false,
  handleClose,
  tempSelectedRows,
  setTempSelectedRows,
  recordGroupType,
  deletedIds,
  setDeletedIds,
  setRecords,
  records,
  exportManagerRecordGroup,
  parentRecordException,
  includeAudit,
  category,
  handleDirty,
  setDataManagerRecordGroupData = () => {},
  importRecordGroupAccess,
  setEditExisting,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {createdForData, createdByData} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  
  const IMRecordGroupSessionStorage = JSON.parse(sessionStorage.getItem('IMRecordGroup'));
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item.value === option ||
          item.key === option ||
          item.userName === option ||
          item.categoryCode === option
        ) {
          label = item;
        }
      });
    return label;
  };
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const categoryData = [
    {
      categoryCode: 'CO',
      categoryName: 'Core',
    },
  ];

  const promptOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const initialValues = {
    importMRGroupCode: '',
    importMRGroupDescripton: '',
    importMRGroupType: recordGroupType ? recordGroupType : '',
    createdDate: null,
    isDraft: mapRecords ? {key: 'N', value: 'Completed'} : '',
    category: category ? getObject(category, categoryData) : '',
    includeAudit: includeAudit ? getObject(includeAudit, promptOptions) : '',
    createdFor: '',
    createdBy: '',
  };
  const [searchData, setSearchData] = useState(initialValues);
  const [submit, setSubmit] = useState(false);
  const tempUnCheckedRef = useRef([]);

  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    sessionStorage.setItem('IMRecordGroup', JSON.stringify(values));
    setSearchData(values);
    setSubmit(true);
  };

  useEffect(() => {
    setEditExisting && setEditExisting(false);
  }, []);

  useEffect(() => {
    dispatch(fetchCreatedForDropDownData('importrecordgroup'));
    dispatch(fetchCreatedByDropDownData('importrecordgroup'));
  }, [dispatch]);
  const onClear = () => {
    const data = {
      importMRGroupCode: '',
      importMRGroupDescripton: '',
      importMRGroupType: recordGroupType?.value ? recordGroupType : '',
      createdDate: null,
      isDraft: mapRecords ? {key: 'N', value: 'Completed'} : '',
      createdFor: '',
      createdBy: '',
    };
    setSearchData(data);
    sessionStorage.removeItem('IMRecordGroup');
  };
  return (
    <div className={mapRecords ? `col-12` : ``}>
      <h2 className="search-title">Import Record Group Search</h2>
      <Formik
        onSubmit={handleSubmit}
        initialValues={
          IMRecordGroupSessionStorage && !mapRecords ? IMRecordGroupSessionStorage : initialValues
        }
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {values, handleChange, handleReset, handleBlur, setFieldValue, touched, errors} =
            props;

          return (
            <div>
              <Form autoComplete="off">
                <div className="form-row  standard-field-textfields new-standard-textfields">
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3`}>
                    <TextField
                      margin="dense"
                      className={`${classes.labelName}`}
                      variant="outlined"
                      placeholder={`Enter ${exportManagerRecordGroup ?  `Export` : `Import`} Record Group Name`}
                      label={`${exportManagerRecordGroup ?  `Export` : `Import`} Record Group Name`}
                      name="importMRGroupCode"
                      value={values?.importMRGroupCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.importMRGroupCode}
                    />
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3`}>
                    <TextField
                      margin="dense"
                      className={`${classes.labelName}`}
                      variant="outlined"
                      placeholder={`Enter ${exportManagerRecordGroup ?  `Export` : `Import`} Record Group Description`}
                      label={`${exportManagerRecordGroup ?  `Export` : `Import`} Record Group Description`}
                      name="importMRGroupDescripton"
                      value={values.importMRGroupDescripton}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="importMRGroupType"
                      id="importMRGroupType"
                      size="small"
                      disabled={mapRecords}
                      value={values.importMRGroupType}
                      options={importManagerType}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('importMRGroupType', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Record Group Type"
                            placeholder="Select Record Gruop Type"
                          />
                        </div>
                      )}
                    />
                  </div>

                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="createdFor"
                      id="createdFor"
                      size="small"
                      value={values.createdFor}
                      options={createdForData || []}
                      getOptionLabel={(option) => {
                        return option && option?.userLoginName ? option?.userLoginName : '';
                      }}
                      renderOption={(option) => {
                        return createForOptions(option);
                      }}
                      onChange={(e, value) => {
                        setFieldValue('createdFor', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Created For"
                            placeholder="Select Created For"
                          />
                        </div>
                      )}
                    />
                  </div>

                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="createdBy"
                      id="createdBy"
                      size="small"
                      value={values.createdBy}
                      options={createdByData || []}
                      getOptionLabel={(option) => {
                        return option && option?.userLoginName ? option?.userLoginName : '';
                      }}
                      renderOption={(option) => {
                        return createdByOptions(option);
                      }}
                      onChange={(e, value) => {
                        setFieldValue('createdBy', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Created By"
                            placeholder="Select Created By"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        className={`${classes.labelName} account-date-picker`}
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        value={values.createdDate}
                        name="createdDate"
                        onBlur={handleBlur}
                        inputVariant="outlined"
                        helperText=""
                        label="Date Created"
                        error={Boolean(touched?.createdDate && errors?.createdDate)}
                        onChange={(val) => {
                          setFieldValue('createdDate', val);
                        }}
                        autoOk
                        margin="dense"
                      />
                    </MuiPickersUtilsProvider>
                    <FormHelperText variant="outlined">
                      {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                    </FormHelperText>
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3`}>
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      name="isDraft"
                      id="isDraft"
                      size="small"
                      options={StatusOptions}
                      required
                      disabled={mapRecords}
                      value={values.isDraft}
                      getOptionLabel={(option) => {
                        return option && option?.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('isDraft', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Status"
                            placeholder="Select Status"
                          />
                        </div>
                      )}
                    />
                  </div>
                  {exportManagerRecordGroup && (
                    <>
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          name="category"
                          id="category"
                          size="small"
                          disabled
                          value={values.category}
                          options={categoryData?.length > 0 ? categoryData : []}
                          getOptionDisabled={(option) => option.categoryCode === ''}
                          getOptionLabel={(option) => {
                            return option && option.categoryName ?
                              option.categoryCode === null ?
                                option.categoryName :
                                option.categoryCode + ' - ' + option.categoryName :
                              '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('category', value);
                          }}
                          placeholder="Select Category"
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                name="category"
                                label="Category"
                                placeholder="Select Category"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          name="includeAudit"
                          id="includeAudit"
                          size="small"
                          disabled
                          options={promptOptions}
                          value={values.includeAudit}
                          getOptionLabel={(option) => {
                            return option && option?.value && option?.key ?
                              `${option?.key + ' - ' + option?.value}` :
                              option?.value;
                          }}
                          onChange={(e, value) => {
                            setFieldValue('includeAudit', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={`${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                // InputLabelProps={{ shrink: true }}
                                label="Include Audit"
                                placeholder="Select Include Audit"
                              />
                            </div>
                          )}
                        />
                      </div>
                    </>
                  )}
                  <div
                    className={
                      mapRecords ?
                        'col-xl-2 col-md-12 col-lg-6 col-xl-6' :
                        'col-xl-2 col-md-4 col-lg-3 col-xl-3'
                    }
                  >
                    <div className="row new-standard-textfields">
                      <div
                        className={
                          mapRecords ? 'col-md-7 col-lg-6 form-group' : 'col-md-12 form-group'
                        }
                      >
                        <div
                          className={
                            mapRecords ?
                              `d-flex justify-content-md-center justify-content-lg-end justify-content-xl-end` :
                              `d-flex justify-content-md-center justify-content-lg-center justify-content-xl-start`
                          }
                        >
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn`}
                            onClick={() => {
                              handleReset();
                              setSubmit(true);
                              onClear();
                            }}
                          >
                            Reset
                          </Button>
                          <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                            Search
                          </Button>
                        </div>
                      </div>

                      {mapRecords ? (
                        <div className="col-md-5 col-lg-6 form-group">
                          <div className="d-flex justify-content-md-end">
                            <Button
                              aria-label="close"
                              variant="outlined"
                              className={`mr-1 reset-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                handleClose();
                              }}
                            >
                              Close
                            </Button>
                            <Button
                              aria-label="save"
                              variant="outlined"
                              className={`ml-1 search-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                const obj = tempSelectFunc('groupCode', '', tempUnCheckedRef);
                                if (mapRecords) {
                                  if (records) {
                                    const [newSelectedRows] =
                                      filteredCheckedData(records, obj, 'recordCode');
                                    const allSelectedRows = [
                                      ...newSelectedRows,
                                      ...tempSelectedRows,
                                    ];
                                    setRecords(allSelectedRows);
                                    setTempSelectedRows(allSelectedRows || []);
                                  }
                                  handleClose();
                                }
                                handleDirty(true);
                              }}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
      <SearchIMRTable
        setValue={setValue}
        searchData={searchData}
        submit={submit}
        setSubmit={setSubmit}
        tempUnCheckedRef={tempUnCheckedRef}
        mapRecords={mapRecords}
        records={records}
        tempSelectedRows={tempSelectedRows}
        setTempSelectedRows={setTempSelectedRows}
        recordGroupType={recordGroupType}
        exportManagerRecordGroup={exportManagerRecordGroup}
        parentRecordException={parentRecordException}
        includeAudit={includeAudit}
        category={category}
        setDataManagerRecordGroupData={setDataManagerRecordGroupData}
        setEditExisting={setEditExisting}
        importRecordGroupAccess={importRecordGroupAccess}
      />
    </div>
  );
}

export default SearchImportMRGroup;
